import React from 'react';
import CarrerasCatalog from '../Components/Catalogos/Carreras/CarrerasCatalog';

export default function CarrerasPage() {
    return (
        <div style={{ padding: '20px' }}>
            <CarrerasCatalog />
        </div>
    );
}
